import { render, staticRenderFns } from "./ViewDisplay.vue?vue&type=template&id=61fd388d&scoped=true&"
import script from "./ViewDisplay.vue?vue&type=script&lang=js&"
export * from "./ViewDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ViewDisplay.vue?vue&type=style&index=0&id=61fd388d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd388d",
  null
  
)

export default component.exports